//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageSelect from "@/components/admin/FileSelect";
import APIService from "@/services/APIService";
import ConfirmDialog from '@/components/ConfirmDialog'
import isEqual from "lodash.isequal"
export default {
  name: "Profile",
  components: { ImageSelect, ConfirmDialog },
  data() {
    return {
      profile: {
        'profile_name': '',
        'profile_street': '',
        'profile_zip': '',
        'profile_city': '',
        'profile_phone': '',
        'profile_email': '',
        'profile_webpage': '',
        'profile_logo': '',
        'profile_short_description': '',
        'profile_contact': ''
      },
      old_profile: [],
      showSnackbar: false
    }
  },
  methods: {
    saveForm() {
      APIService.updateProfile(this.profile).then(() => {
        this.old_profile = this.profile
        console.log('Profile successfully saved')
        this.showSnackbar = true
      })
    },
    hasChanged() {
      return !isEqual(this.old_profile, this.profile)
    }
  },
  beforeRouteLeave(to, from, next) {
    if(!this.hasChanged()) {
      next()
    } else {
      this.$refs.confirmDialog.show(`Möchten sie die gemachten Änderungen verwerfen?`, 'Verwerfen')
          .then(() => next())
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    APIService.getProfile().then((profile) => {
      next(vm => {
        vm.profile = profile
        vm.old_profile = { ...profile }
      })
    })
  }
}
